import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "post" };
import { ref, reactive } from "vue";
import imgUpload from "@/components/Upload.vue";
import { ElMessage } from "element-plus";
import { updateAboutInfo } from "@/api/about";
export default /*@__PURE__*/ _defineComponent({
    __name: 'post',
    emits: ["saved"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const dialogVisible = ref(false);
        const title = ref("修改公司信息");
        const companyImgUrl = ref([]);
        const companyImgIds = ref([]);
        const form = reactive({
            companyContent: "",
            developmentYears: 0,
            customerCount: 0,
            teamMemberCount: 0,
        });
        const onUpload = (val) => {
            companyImgUrl.value = val.pictureUrls;
            companyImgIds.value = val.pictureIds;
        };
        const show = (data) => {
            form.companyContent = data?.companyContent || "";
            form.developmentYears = data?.developmentYears || 0;
            form.customerCount = data?.customerCount || 0;
            form.teamMemberCount = data?.teamMemberCount || 0;
            companyImgUrl.value = data?.companyImage ? [data.companyImage] : [];
            companyImgIds.value = [];
            dialogVisible.value = true;
        };
        const handleConfirm = async () => {
            try {
                await updateAboutInfo({
                    id: "1",
                    companyContent: form.companyContent,
                    companyImage: companyImgUrl.value[0] || "",
                    developmentYears: form.developmentYears,
                    customerCount: form.customerCount,
                    teamMemberCount: form.teamMemberCount,
                });
                ElMessage.success("保存成功");
                dialogVisible.value = false;
                emit("saved");
            }
            catch {
                ElMessage.error("保存失败");
            }
        };
        __expose({ show });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_dialog, {
                    modelValue: dialogVisible.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((dialogVisible).value = $event)),
                    title: title.value,
                    "close-on-click-modal": false,
                    center: "",
                    style: { "width": "30%" }
                }, {
                    footer: _withCtx(() => [
                        _createVNode(_component_el_button, {
                            onClick: _cache[5] || (_cache[5] = ($event) => (dialogVisible.value = false))
                        }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                    _createTextVNode("取消", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: handleConfirm
                        }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createTextVNode("确认", -1)
                                ]))]),
                            _: 1
                        })
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                            model: form,
                            ref: "formRef",
                            "label-width": "auto",
                            size: "default"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "公司内容：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.companyContent,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.companyContent) = $event)),
                                            type: "textarea",
                                            rows: 4,
                                            placeholder: "请填写公司内容"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "公司展示：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(imgUpload, {
                                            imgUrl: companyImgUrl.value,
                                            imgIds: companyImgIds.value,
                                            onUploader: _cache[1] || (_cache[1] = (v) => onUpload(v))
                                        }, null, 8, ["imgUrl", "imgIds"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "发展经验：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.developmentYears,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.developmentYears) = $event)),
                                            modelModifiers: { number: true },
                                            type: "number",
                                            placeholder: "请填写发展经验"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "合作客户：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.customerCount,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.customerCount) = $event)),
                                            modelModifiers: { number: true },
                                            type: "number",
                                            placeholder: "请填写合作客户"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "团队成员：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.teamMemberCount,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.teamMemberCount) = $event)),
                                            modelModifiers: { number: true },
                                            type: "number",
                                            placeholder: "请填写团队成员"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["model"])
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"])
            ]));
        };
    }
});
